import { render, staticRenderFns } from "./Majorsys.vue?vue&type=template&id=5437a527"
import script from "./Majorsys.vue?vue&type=script&lang=ts"
export * from "./Majorsys.vue?vue&type=script&lang=ts"
import style0 from "./Majorsys.vue?vue&type=style&index=0&id=5437a527&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports